import script from "./email-index.vue?vue&type=script&setup=true&lang=js"
export * from "./email-index.vue?vue&type=script&setup=true&lang=js"

import "./email-index.vue?vue&type=style&index=0&id=6cfff281&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfff281"]])

export default __exports__